import React, { useEffect, useState } from 'react';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import './hospitalSealComponent.less';
import { Button, Col, Row, Upload } from 'antd';
import { ReactComponent as HospitalSeal } from '../../../assets/images/svg/hospital_seal_Icon.svg';
import { UploadChangeParam, UploadFile, UploadProps } from 'antd/lib/upload/interface';
import { centeredNotification } from '../../../utils/utility';
import {
  APPLICATION_ID_2,
  CASHLESS_FORM_CONSTANTS,
  COMMON_ERROR, FETCH_FILE_BYTES, FILE_EXCEED_MESSAGE, FILE_EXTENSION, HOSPITAL_MAX_FILE_SIZE,
  HOSPITAL_SEAL_FILE_FORMAT, HOSPITAL_SEAL_SUPPORTED_FORMATS,
  INVALID_DATE,
  UPLOADED_ON_TIME_FORMAT,
} from '../../../shared/constants/commonConstants';
import { ReactComponent as DeleteIcon } from '../../../assets/images/svg/Dustbin-delete.svg';
import { ReactComponent as File_Icon } from '../../../assets/images/svg/Hosp_Seal.svg';
import { ReactComponent as Plus_Icon } from '../../../assets/images/svg/Plus_icon.svg';
import { ReactComponent as Cross_Icon } from '../../../assets/images/svg/Cross_Red_Filled_Icon.svg';
import { useDispatch } from 'react-redux';
import { updateHospitalSeal } from '../../../store/actions/hospitalAction';
import SendRequest from '../../../shared/services/sendRequest.service';
import { format, isValid, parseISO } from 'date-fns';
import loader from '../../../assets/images/lottie-json/lottie_loading.json';
import Lottie from 'react-lottie';

const HospitalSealComponent = (): any => {
  const TabName = 'Hospital Seal';
  const dispatch = useDispatch();
  const hospitalSealItem = JSON.parse(localStorage?.getItem(CASHLESS_FORM_CONSTANTS.HOSPITALSEAL) || '{}');

  const [fileList, setFileList] = useState<UploadFile<any>[]>([]);
  const [hospitalSealUrl, setHospitalSealUrl] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // File validations
  const fileBeforeUpload = (file: File): boolean => {
    if (file?.size > HOSPITAL_MAX_FILE_SIZE) {
      centeredNotification(FILE_EXCEED_MESSAGE);
      return false;
    }

    if (!HOSPITAL_SEAL_SUPPORTED_FORMATS?.['fileFormats']?.includes(file?.type)) {
      centeredNotification(HOSPITAL_SEAL_SUPPORTED_FORMATS?.['fileErrorMessage']);
      return false;
    }
    return true;
  };

  useEffect((): any => {
    // After file is uploaded, set the loader to show and then delay showing the image
    if (isLoading) {
      const timer = setTimeout((): any => {
        setIsLoading(false);
      }, 800);
      return (): any => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect((): any => {
    getFileBytes(hospitalSealItem?.guid);
  }, [fileList]);

  const deleteFile = (): any => {
    setFileList([]);
    dispatch(updateHospitalSeal('', CASHLESS_FORM_CONSTANTS.HOSPITALSEAL));
    localStorage?.removeItem(CASHLESS_FORM_CONSTANTS.HOSPITALSEAL);

  };

  const getFileBytes = async (guid: any): Promise<any> => {
    const request = {
      applicationId: APPLICATION_ID_2,
      fileIdentifiers: [guid],
    };
    if (guid) {
      const result = await SendRequest.instance.post(process.env.REACT_APP_BASE_URL + FETCH_FILE_BYTES, request);
      setHospitalSealUrl(result?.fileDetails?.[0]?.fileBytes);
      return result;
    } else {
      setHospitalSealUrl([]);
    }
  };

  const modifiedOn = hospitalSealItem?.modifiedOn;

  const formattedDate = modifiedOn && isValid(parseISO(modifiedOn))
    ? format(parseISO(modifiedOn), UPLOADED_ON_TIME_FORMAT)
    : INVALID_DATE;

  const draggerActions: UploadProps = {
    showUploadList: true,
    beforeUpload: fileBeforeUpload,
    multiple: true,
    action: process.env.REACT_APP_BASE_URL + 'File/Upload',
    // headers: { accessToken: ApplicationDetail.instance.getAccessToken() },
    withCredentials: true,
    onChange: async (info: UploadChangeParam<UploadFile<any>>): Promise<any> => {

      if (info?.file?.status === 'done') {
        const { isSuccess, errorMessage, fileUploadDetails } = info?.file?.response || {};
        const formData = new FormData() as any;
        formData.append('FileUploadType', CASHLESS_FORM_CONSTANTS.HOSPITALSEAL);

        if (isSuccess) {
          const fileGuid = fileUploadDetails?.[0]?.fileGuid;
          const fileModifiedOn = new Date()?.toISOString();
          setFileList((prevList: any): any => [...prevList, info.file]);
          const hospitalSealData = { guid: fileGuid, modifiedOn: fileModifiedOn };
          localStorage?.setItem(CASHLESS_FORM_CONSTANTS.HOSPITALSEAL, JSON?.stringify(hospitalSealData));
          getFileBytes(fileUploadDetails?.[0]?.fileGuid);
          dispatch(updateHospitalSeal(fileUploadDetails?.[0]?.fileGuid, CASHLESS_FORM_CONSTANTS.HOSPITALSEAL));
          setIsLoading(true);
        } else {
          centeredNotification(errorMessage || COMMON_ERROR);
        }
      } else if (info?.file?.status === 'removed') {
        setFileList((prevList: any): any => prevList.filter((f: any): any => f.uid !== info.file.uid));
      }
    },
    fileList,
    data: (file: any): any => {
      return {
        FileUploadType: CASHLESS_FORM_CONSTANTS.HOSPITALSEAL, // FileUploadType to be sent with the upload
        ApplicationId: APPLICATION_ID_2,
      };
    },
  };

  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <>
      <div className="hospital-seal-container">
        <div>
          <PageHeader colSize={18}
            pageTitle={TabName}
            className="hospital-seal-text"
            isHospitalSeal={true}
          />
        </div>
      </div>
      {hospitalSealUrl?.length > 0 ?
        <div className="hosp-seal-uploaded-files">
          <Row className="updated-seal-container">
            <Col md={4} className="display-flex">
              <File_Icon />
              <p className="uploaded-hosp-name">{CASHLESS_FORM_CONSTANTS.FILE_NAME}</p>
            </Col>
            {isLoading ?
              <Col md={10} className="lottie-icon-loader">
                <Lottie options={defaultLottieOptions} />
              </Col> :
              <Col md={10} className="image-cls">
                <img
                  className="hospital-seal-image hospital-seal"
                  src={`data:image/jpeg;base64,${hospitalSealUrl}`}
                  alt="Hospital Logo"
                />
              </Col>}
            {isLoading ? <Col md={4} className="cross-icon-filled">
              <Cross_Icon /></Col> : <Col md={7} className="uploaded-text"><span className="date">
                {CASHLESS_FORM_CONSTANTS.UPLOADED_ON} </span>&nbsp; {formattedDate}
              <span className="delete-icon-seal" onClick={deleteFile}><DeleteIcon /></span>
            </Col>}
          </Row>
        </div>
        : <div>
          <div className="seal-upload-container">
            <Row className="file-upload-row">
              <span
                dangerouslySetInnerHTML={{ __html: CASHLESS_FORM_CONSTANTS.HOSPITAL_SEAL_UPLOAD }}
              />
            </Row>
          </div>
          <Row className="row-center readonly-inpt">
            <HospitalSeal />
          </Row>
          <Row className="row-center hosp-seal-ml-14">
            <Upload
              {...draggerActions}
              itemRender={(): any => null}
            >
              <Button className="btn-seal" type="primary"><Plus_Icon /> {CASHLESS_FORM_CONSTANTS.ADD_HOSPITAL_SEAL}</Button>
            </Upload>
          </Row>
          <div className="centered-container">
            <span className="fileType">
              {HOSPITAL_SEAL_FILE_FORMAT} <span className="file-extensions">{FILE_EXTENSION}</span>
              <br />
              <span className="fileSize">{FILE_EXCEED_MESSAGE}</span>
            </span>
          </div>
        </div>}
    </>
  );
};
export default HospitalSealComponent;
